var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInternetPlanHover(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "426px",
    height: "426px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.99
    },
    fill: "#fefefe",
    d: "M 357.5,288.5 C 356.833,288.5 356.5,288.833 356.5,289.5C 350.249,290.58 345.916,294.08 343.5,300C 339.789,300.825 336.122,300.659 332.5,299.5C 328.679,294.01 323.679,290.01 317.5,287.5C 316.5,253.84 316.167,220.173 316.5,186.5C 319.249,186.726 321.916,186.393 324.5,185.5C 325.612,180.171 325.612,174.838 324.5,169.5C 324.737,168.209 324.404,167.209 323.5,166.5C 323.043,160.28 322.043,154.28 320.5,148.5C 320.5,146.5 320.5,144.5 320.5,142.5C 320.737,141.209 320.404,140.209 319.5,139.5C 319.5,138.5 319.5,137.5 319.5,136.5C 319.768,134.901 319.434,133.568 318.5,132.5C 318.768,129.881 318.435,127.381 317.5,125C 293.167,124.667 268.833,124.333 244.5,124C 269.003,123.832 293.337,123.332 317.5,122.5C 317.152,118.742 316.485,115.076 315.5,111.5C 315.5,111.167 315.5,110.833 315.5,110.5C 315.152,106.742 314.485,103.076 313.5,99.5C 313.5,97.8333 313.5,96.1667 313.5,94.5C 313.101,90.9891 312.434,87.6557 311.5,84.5C 311.702,82.0504 311.369,79.717 310.5,77.5C 310.158,76.6618 309.492,76.3284 308.5,76.5C 280.264,75.8254 251.931,75.1588 223.5,74.5C 227.18,79.1794 231.514,83.1794 236.5,86.5C 239.231,90.2343 242.564,93.2343 246.5,95.5C 248.5,97.8333 250.5,100.167 252.5,102.5C 250.376,104.174 248.042,105.007 245.5,105C 241.167,100.667 236.833,96.3333 232.5,92C 231.833,91.3333 231.167,91.3333 230.5,92C 234.333,95.8333 238.167,99.6667 242,103.5C 242.5,121.497 242.667,139.497 242.5,157.5C 219.425,157.822 196.425,157.489 173.5,156.5C 173.333,138.83 173.5,121.164 174,103.5C 174.717,102.956 175.217,102.289 175.5,101.5C 173.264,102.389 171.264,103.722 169.5,105.5C 167.684,104.185 166.017,102.685 164.5,101C 165.71,99.9609 166.71,98.7942 167.5,97.5C 170.764,95.9059 173.431,93.5725 175.5,90.5C 178.764,88.9059 181.431,86.5725 183.5,83.5C 188.801,79.5336 193.801,75.2003 198.5,70.5C 196.114,71.3733 194.114,72.8733 192.5,75C 178.837,75.4999 165.171,75.6666 151.5,75.5C 162.903,69.2958 174.236,62.7958 185.5,56C 206.793,43.9026 229.46,35.5692 253.5,31C 308.651,25.1604 350.818,45.6604 380,92.5C 399.854,122.896 411.021,156.23 413.5,192.5C 410.169,228.986 393.836,258.152 364.5,280C 361.577,282.416 359.243,285.25 357.5,288.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5b5a5a",
    d: "M 206.5,63.5 C 208.519,60.8664 210.519,61.033 212.5,64C 211.004,64.5074 209.837,64.0074 209,62.5C 208.329,63.2524 207.496,63.5858 206.5,63.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6c6c6b",
    d: "M 206.5,63.5 C 204.431,66.5725 201.764,68.9059 198.5,70.5C 200.569,67.4275 203.236,65.0941 206.5,63.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#616060",
    d: "M 223.5,74.5 C 220.101,72.6117 217.101,70.1117 214.5,67C 218.143,68.4546 221.143,70.9546 223.5,74.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.816
    },
    fill: "#2a2a29",
    d: "M 148.5,75.5 C 148.5,75.8333 148.5,76.1667 148.5,76.5C 133.83,76.3334 119.163,76.5001 104.5,77C 102.75,78.7542 102.083,80.9208 102.5,83.5C 101.833,83.5 101.167,83.5 100.5,83.5C 100.779,80.8822 101.446,78.3822 102.5,76C 117.83,75.5001 133.163,75.3334 148.5,75.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#565656",
    d: "M 198.5,70.5 C 193.801,75.2003 188.801,79.5336 183.5,83.5C 185.294,81.2034 187.294,79.0367 189.5,77C 175.837,76.5001 162.171,76.3334 148.5,76.5C 148.5,76.1667 148.5,75.8333 148.5,75.5C 149.5,75.5 150.5,75.5 151.5,75.5C 165.171,75.6666 178.837,75.4999 192.5,75C 194.114,72.8733 196.114,71.3733 198.5,70.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#585858",
    d: "M 223.5,74.5 C 251.931,75.1588 280.264,75.8254 308.5,76.5C 281.498,76.3334 254.498,76.5 227.5,77C 230.754,80.0827 233.754,83.2494 236.5,86.5C 231.514,83.1794 227.18,79.1794 223.5,74.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#cedde4",
    d: "M 148.5,76.5 C 162.171,76.3334 175.837,76.5001 189.5,77C 187.294,79.0367 185.294,81.2034 183.5,83.5C 181.938,83.7329 180.605,84.3995 179.5,85.5C 153.478,86.1575 127.812,85.4908 102.5,83.5C 102.083,80.9208 102.75,78.7542 104.5,77C 119.163,76.5001 133.83,76.3334 148.5,76.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ccdae1",
    d: "M 308.5,76.5 C 309.492,76.3284 310.158,76.6618 310.5,77.5C 309.888,80.304 309.888,83.304 310.5,86.5C 286.5,86.5 262.5,86.5 238.5,86.5C 237.833,86.5 237.167,86.5 236.5,86.5C 233.754,83.2494 230.754,80.0827 227.5,77C 254.498,76.5 281.498,76.3334 308.5,76.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#727271",
    d: "M 209.5,71.5 C 205.773,75.2332 201.773,78.5665 197.5,81.5C 200.629,77.8691 203.963,74.3691 207.5,71C 208.437,70.3083 209.103,70.475 209.5,71.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#616060",
    d: "M 209.5,71.5 C 214.908,75.4002 219.908,79.9002 224.5,85C 218.842,81.5233 213.842,77.0233 209.5,71.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.989
    },
    fill: "#fefefe",
    d: "M 100.5,83.5 C 100.5,84.8333 100.5,86.1667 100.5,87.5C 99.7564,91.1185 99.423,94.7852 99.5,98.5C 99.5,98.8333 99.5,99.1667 99.5,99.5C 98.9084,102.127 98.5751,104.794 98.5,107.5C 98.5,108.833 98.5,110.167 98.5,111.5C 97.6586,113.379 97.3253,115.379 97.5,117.5C 97.5,118.5 97.5,119.5 97.5,120.5C 96.5655,121.568 96.2322,122.901 96.5,124.5C 96.5,126.5 96.5,128.5 96.5,130.5C 95.5109,136.322 94.8442,142.322 94.5,148.5C 94.5,148.833 94.5,149.167 94.5,149.5C 93.3318,160.518 91.9984,171.518 90.5,182.5C 90.968,184.134 91.968,185.3 93.5,186C 96.146,186.497 98.8127,186.664 101.5,186.5C 101.5,237.5 101.5,288.5 101.5,339.5C 98.4752,340.033 97.1419,341.867 97.5,345C 97.0904,347.575 98.0904,349.242 100.5,350C 172.5,350.667 244.5,350.667 316.5,350C 317.691,349.302 318.691,348.469 319.5,347.5C 322.059,347.198 324.393,347.532 326.5,348.5C 247.136,408.792 166.136,410.959 83.5,355C 63.9577,341.125 47.4577,324.291 34,304.5C 26.5172,289.244 21.1839,273.244 18,256.5C 10.05,222.991 9.04998,189.325 15,155.5C 22.4507,125.72 40.284,104.887 68.5,93C 78.803,88.5911 89.4697,85.4245 100.5,83.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b1bbbe",
    d: "M 100.5,83.5 C 101.167,83.5 101.833,83.5 102.5,83.5C 127.812,85.4908 153.478,86.1575 179.5,85.5C 153.264,86.1752 126.931,86.8418 100.5,87.5C 100.5,86.1667 100.5,84.8333 100.5,83.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5f5f5f",
    d: "M 183.5,83.5 C 181.431,86.5725 178.764,88.9059 175.5,90.5C 163.519,89.1676 151.185,88.5009 138.5,88.5C 125.995,88.5001 113.662,88.8334 101.5,89.5C 101.492,92.5448 101.159,95.5448 100.5,98.5C 100.167,98.5 99.8333,98.5 99.5,98.5C 99.423,94.7852 99.7564,91.1185 100.5,87.5C 126.931,86.8418 153.264,86.1752 179.5,85.5C 180.605,84.3995 181.938,83.7329 183.5,83.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#616161",
    d: "M 310.5,77.5 C 311.369,79.717 311.702,82.0504 311.5,84.5C 311.5,85.8333 311.5,87.1667 311.5,88.5C 287.833,88.5 264.167,88.5 240.5,88.5C 239.5,88.1667 238.833,87.5 238.5,86.5C 262.5,86.5 286.5,86.5 310.5,86.5C 309.888,83.304 309.888,80.304 310.5,77.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#706f6f",
    d: "M 226.5,87.5 C 228.337,87.6395 228.67,88.3061 227.5,89.5C 226.702,89.0431 226.369,88.3764 226.5,87.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2a2929",
    d: "M 236.5,86.5 C 237.167,86.5 237.833,86.5 238.5,86.5C 238.833,87.5 239.5,88.1667 240.5,88.5C 240.5,89.1667 240.833,89.5 241.5,89.5C 243.167,91.5 244.833,93.5 246.5,95.5C 242.564,93.2343 239.231,90.2343 236.5,86.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b4bec2",
    d: "M 101.5,89.5 C 113.662,88.8334 125.995,88.5001 138.5,88.5C 151.185,88.5009 163.519,89.1676 175.5,90.5C 175.167,90.5 174.833,90.5 174.5,90.5C 150.339,89.5024 126.006,89.169 101.5,89.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#787777",
    d: "M 197.5,81.5 C 194.437,85.5658 190.771,88.8991 186.5,91.5C 189.563,87.4342 193.229,84.1009 197.5,81.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#afb7bb",
    d: "M 311.5,84.5 C 312.434,87.6557 313.101,90.9891 313.5,94.5C 312.662,94.8417 312.328,95.5084 312.5,96.5C 311.532,94.3926 311.198,92.0593 311.5,89.5C 288.167,89.5 264.833,89.5 241.5,89.5C 240.833,89.5 240.5,89.1667 240.5,88.5C 264.167,88.5 287.833,88.5 311.5,88.5C 311.5,87.1667 311.5,85.8333 311.5,84.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d1e1e8",
    d: "M 101.5,89.5 C 126.006,89.169 150.339,89.5024 174.5,90.5C 171.833,92.5 169.5,94.8333 167.5,97.5C 145.212,98.4788 122.879,98.8121 100.5,98.5C 101.159,95.5448 101.492,92.5448 101.5,89.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d1e1e8",
    d: "M 241.5,89.5 C 264.833,89.5 288.167,89.5 311.5,89.5C 311.198,92.0593 311.532,94.3926 312.5,96.5C 302.522,97.832 292.189,98.4987 281.5,98.5C 271.167,98.3333 260.833,98.1667 250.5,98C 249.529,96.5187 248.196,95.6854 246.5,95.5C 244.833,93.5 243.167,91.5 241.5,89.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3c3b3b",
    d: "M 193.5,94.5 C 203.569,93.1712 213.735,93.1712 224,94.5C 224.5,113.164 224.667,131.83 224.5,150.5C 224.167,150.5 223.833,150.5 223.5,150.5C 223.667,132.164 223.5,113.83 223,95.5C 213.25,94.5144 203.416,94.181 193.5,94.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3b3b3b",
    d: "M 174.5,90.5 C 174.833,90.5 175.167,90.5 175.5,90.5C 173.431,93.5725 170.764,95.9059 167.5,97.5C 169.5,94.8333 171.833,92.5 174.5,90.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdfdfe",
    d: "M 193.5,94.5 C 203.416,94.181 213.25,94.5144 223,95.5C 223.5,113.83 223.667,132.164 223.5,150.5C 213.667,151.821 203.833,151.821 194,150.5C 193.5,131.836 193.333,113.17 193.5,94.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#999998",
    d: "M 193.5,94.5 C 193.333,113.17 193.5,131.836 194,150.5C 203.833,151.821 213.667,151.821 223.5,150.5C 223.833,150.5 224.167,150.5 224.5,150.5C 224.047,151.458 223.381,152.292 222.5,153C 213.167,153.667 203.833,153.667 194.5,153C 193.692,152.692 193.025,152.192 192.5,151.5C 191.347,132.877 191.18,114.21 192,95.5C 192.383,94.944 192.883,94.6107 193.5,94.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#797978",
    d: "M 186.5,91.5 C 183.437,95.5658 179.771,98.8991 175.5,101.5C 178.563,97.4342 182.229,94.1009 186.5,91.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d2e2e9",
    d: "M 197.5,98.5 C 205.087,98.1858 212.587,98.5192 220,99.5C 220.667,115.167 220.667,130.833 220,146.5C 212.253,147.482 204.42,147.815 196.5,147.5C 196.182,131.089 196.516,114.756 197.5,98.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0c0c0c",
    d: "M 313.5,94.5 C 313.5,96.1667 313.5,97.8333 313.5,99.5C 293.164,99.3334 272.831,99.5 252.5,100C 253.056,100.383 253.389,100.883 253.5,101.5C 253.5,101.833 253.5,102.167 253.5,102.5C 253.167,102.5 252.833,102.5 252.5,102.5C 250.5,100.167 248.5,97.8333 246.5,95.5C 248.196,95.6854 249.529,96.5187 250.5,98C 260.833,98.1667 271.167,98.3333 281.5,98.5C 292.189,98.4987 302.522,97.832 312.5,96.5C 312.328,95.5084 312.662,94.8417 313.5,94.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#909495",
    d: "M 99.5,99.5 C 121.193,98.8445 142.526,99.5112 163.5,101.5C 142.5,101.5 121.5,101.5 100.5,101.5C 100.483,103.565 100.15,105.565 99.5,107.5C 99.1667,107.5 98.8333,107.5 98.5,107.5C 98.5751,104.794 98.9084,102.127 99.5,99.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8e9293",
    d: "M 313.5,99.5 C 314.485,103.076 315.152,106.742 315.5,110.5C 315.167,110.5 314.833,110.5 314.5,110.5C 313.701,107.57 313.368,104.57 313.5,101.5C 293.5,101.5 273.5,101.5 253.5,101.5C 253.389,100.883 253.056,100.383 252.5,100C 272.831,99.5 293.164,99.3334 313.5,99.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d1e1e8",
    d: "M 163.5,101.5 C 165.267,105.492 168.101,106.825 172,105.5C 172.494,107.134 172.66,108.801 172.5,110.5C 148.167,110.5 123.833,110.5 99.5,110.5C 99.5,109.5 99.5,108.5 99.5,107.5C 100.15,105.565 100.483,103.565 100.5,101.5C 121.5,101.5 142.5,101.5 163.5,101.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d1e1e8",
    d: "M 253.5,101.5 C 273.5,101.5 293.5,101.5 313.5,101.5C 313.368,104.57 313.701,107.57 314.5,110.5C 291.167,110.5 267.833,110.5 244.5,110.5C 244.238,109.022 244.571,107.689 245.5,106.5C 246.086,106.709 246.586,107.043 247,107.5C 249.352,105.97 251.519,104.303 253.5,102.5C 253.5,102.167 253.5,101.833 253.5,101.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#929596",
    d: "M 98.5,111.5 C 123.523,110.843 148.189,111.51 172.5,113.5C 148.158,113.167 123.824,113.5 99.5,114.5C 98.8728,115.417 98.5394,116.417 98.5,117.5C 98.1667,117.5 97.8333,117.5 97.5,117.5C 97.3253,115.379 97.6586,113.379 98.5,111.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#909394",
    d: "M 315.5,111.5 C 316.485,115.076 317.152,118.742 317.5,122.5C 316.833,122.5 316.167,122.5 315.5,122.5C 315.726,119.751 315.393,117.084 314.5,114.5C 291.176,113.5 267.843,113.167 244.5,113.5C 267.81,111.51 291.476,110.843 315.5,111.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d1e1e8",
    d: "M 172.5,113.5 C 172.5,116.5 172.5,119.5 172.5,122.5C 147.833,122.5 123.167,122.5 98.5,122.5C 98.5,120.833 98.5,119.167 98.5,117.5C 98.5394,116.417 98.8728,115.417 99.5,114.5C 123.824,113.5 148.158,113.167 172.5,113.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d1e1e8",
    d: "M 244.5,113.5 C 267.843,113.167 291.176,113.5 314.5,114.5C 315.393,117.084 315.726,119.751 315.5,122.5C 291.833,122.5 268.167,122.5 244.5,122.5C 244.5,119.5 244.5,116.5 244.5,113.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5d5d5e",
    d: "M 97.5,117.5 C 97.8333,117.5 98.1667,117.5 98.5,117.5C 98.5,119.167 98.5,120.833 98.5,122.5C 123.167,122.5 147.833,122.5 172.5,122.5C 172.5,122.833 172.5,123.167 172.5,123.5C 147.5,123.5 122.5,123.5 97.5,123.5C 97.5,122.5 97.5,121.5 97.5,120.5C 97.5,119.5 97.5,118.5 97.5,117.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ababaa",
    d: "M 97.5,120.5 C 97.5,121.5 97.5,122.5 97.5,123.5C 122.5,123.5 147.5,123.5 172.5,123.5C 172.5,123.833 172.5,124.167 172.5,124.5C 147.167,124.5 121.833,124.5 96.5,124.5C 96.2322,122.901 96.5655,121.568 97.5,120.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5c5c5c",
    d: "M 96.5,124.5 C 121.833,124.5 147.167,124.5 172.5,124.5C 172.5,124.833 172.5,125.167 172.5,125.5C 147.5,125.5 122.5,125.5 97.5,125.5C 97.5,127.833 97.5,130.167 97.5,132.5C 96.6618,132.158 96.3284,131.492 96.5,130.5C 96.5,128.5 96.5,126.5 96.5,124.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d1e1e8",
    d: "M 172.5,125.5 C 172.5,128.5 172.5,131.5 172.5,134.5C 147.144,135.157 122.144,134.491 97.5,132.5C 97.5,130.167 97.5,127.833 97.5,125.5C 122.5,125.5 147.5,125.5 172.5,125.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#939696",
    d: "M 96.5,130.5 C 96.3284,131.492 96.6618,132.158 97.5,132.5C 122.144,134.491 147.144,135.157 172.5,134.5C 147.35,136.164 122.016,137.164 96.5,137.5C 96.5,140.5 96.5,143.5 96.5,146.5C 121.833,146.5 147.167,146.5 172.5,146.5C 146.855,148.491 120.855,149.158 94.5,148.5C 94.8442,142.322 95.5109,136.322 96.5,130.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#999a9a",
    d: "M 318.5,132.5 C 319.434,133.568 319.768,134.901 319.5,136.5C 294.5,136.5 269.5,136.5 244.5,136.5C 244.5,135.833 244.5,135.167 244.5,134.5C 268.833,134.5 293.167,134.5 317.5,134.5C 318.42,135.067 318.754,134.401 318.5,132.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#434343",
    d: "M 252.5,102.5 C 252.833,102.5 253.167,102.5 253.5,102.5C 251.519,104.303 249.352,105.97 247,107.5C 246.586,107.043 246.086,106.709 245.5,106.5C 244.571,107.689 244.238,109.022 244.5,110.5C 267.833,110.5 291.167,110.5 314.5,110.5C 314.833,110.5 315.167,110.5 315.5,110.5C 315.5,110.833 315.5,111.167 315.5,111.5C 291.476,110.843 267.81,111.51 244.5,113.5C 244.5,116.5 244.5,119.5 244.5,122.5C 268.167,122.5 291.833,122.5 315.5,122.5C 316.167,122.5 316.833,122.5 317.5,122.5C 293.337,123.332 269.003,123.832 244.5,124C 268.833,124.333 293.167,124.667 317.5,125C 318.435,127.381 318.768,129.881 318.5,132.5C 318.754,134.401 318.42,135.067 317.5,134.5C 317.296,131.482 316.963,128.482 316.5,125.5C 292.5,125.5 268.5,125.5 244.5,125.5C 244.5,128.5 244.5,131.5 244.5,134.5C 244.5,135.167 244.5,135.833 244.5,136.5C 243.167,136.833 243.167,137.167 244.5,137.5C 244.5,140.5 244.5,143.5 244.5,146.5C 269.478,148.491 294.811,149.157 320.5,148.5C 320.5,148.833 320.5,149.167 320.5,149.5C 295.167,149.5 269.833,149.5 244.5,149.5C 244.632,152.57 244.299,155.57 243.5,158.5C 243.167,158.5 242.833,158.5 242.5,158.5C 242.5,158.167 242.5,157.833 242.5,157.5C 242.667,139.497 242.5,121.497 242,103.5C 238.167,99.6667 234.333,95.8333 230.5,92C 231.167,91.3333 231.833,91.3333 232.5,92C 236.833,96.3333 241.167,100.667 245.5,105C 248.042,105.007 250.376,104.174 252.5,102.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d1e1e8",
    d: "M 317.5,134.5 C 293.167,134.5 268.833,134.5 244.5,134.5C 244.5,131.5 244.5,128.5 244.5,125.5C 268.5,125.5 292.5,125.5 316.5,125.5C 316.963,128.482 317.296,131.482 317.5,134.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#020202",
    d: "M 244.5,136.5 C 269.5,136.5 294.5,136.5 319.5,136.5C 319.5,137.5 319.5,138.5 319.5,139.5C 294.728,137.524 269.728,136.858 244.5,137.5C 243.167,137.167 243.167,136.833 244.5,136.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d1e2e8",
    d: "M 96.5,137.5 C 121.833,137.5 147.167,137.5 172.5,137.5C 172.5,140.5 172.5,143.5 172.5,146.5C 147.167,146.5 121.833,146.5 96.5,146.5C 96.5,143.5 96.5,140.5 96.5,137.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d1e1e8",
    d: "M 244.5,137.5 C 269.728,136.858 294.728,137.524 319.5,139.5C 320.404,140.209 320.737,141.209 320.5,142.5C 319.566,143.568 319.232,144.901 319.5,146.5C 294.5,146.5 269.5,146.5 244.5,146.5C 244.5,143.5 244.5,140.5 244.5,137.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#939596",
    d: "M 320.5,142.5 C 320.5,144.5 320.5,146.5 320.5,148.5C 294.811,149.157 269.478,148.491 244.5,146.5C 269.5,146.5 294.5,146.5 319.5,146.5C 319.232,144.901 319.566,143.568 320.5,142.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#070707",
    d: "M 167.5,97.5 C 166.71,98.7942 165.71,99.9609 164.5,101C 166.017,102.685 167.684,104.185 169.5,105.5C 171.264,103.722 173.264,102.389 175.5,101.5C 175.217,102.289 174.717,102.956 174,103.5C 173.5,121.164 173.333,138.83 173.5,156.5C 172.532,154.393 172.198,152.059 172.5,149.5C 146.833,149.5 121.167,149.5 95.5,149.5C 95.1667,149.5 94.8333,149.5 94.5,149.5C 94.5,149.167 94.5,148.833 94.5,148.5C 120.855,149.158 146.855,148.491 172.5,146.5C 172.5,143.5 172.5,140.5 172.5,137.5C 147.167,137.5 121.833,137.5 96.5,137.5C 122.016,137.164 147.35,136.164 172.5,134.5C 172.5,131.5 172.5,128.5 172.5,125.5C 172.5,125.167 172.5,124.833 172.5,124.5C 172.5,124.167 172.5,123.833 172.5,123.5C 172.5,123.167 172.5,122.833 172.5,122.5C 172.5,119.5 172.5,116.5 172.5,113.5C 148.189,111.51 123.523,110.843 98.5,111.5C 98.5,110.167 98.5,108.833 98.5,107.5C 98.8333,107.5 99.1667,107.5 99.5,107.5C 99.5,108.5 99.5,109.5 99.5,110.5C 123.833,110.5 148.167,110.5 172.5,110.5C 172.66,108.801 172.494,107.134 172,105.5C 168.101,106.825 165.267,105.492 163.5,101.5C 142.526,99.5112 121.193,98.8445 99.5,99.5C 99.5,99.1667 99.5,98.8333 99.5,98.5C 99.8333,98.5 100.167,98.5 100.5,98.5C 122.879,98.8121 145.212,98.4788 167.5,97.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#cfdee5",
    d: "M 322.5,168.5 C 246.507,170.497 170.174,171.164 93.5,170.5C 93.5079,167.455 93.8413,164.455 94.5,161.5C 170.17,161.167 245.836,161.5 321.5,162.5C 322.348,164.409 322.682,166.409 322.5,168.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b4bec2",
    d: "M 323.5,166.5 C 324.404,167.209 324.737,168.209 324.5,169.5C 286.045,170.827 247.378,171.494 208.5,171.5C 169.999,171.5 131.665,171.167 93.5,170.5C 170.174,171.164 246.507,170.497 322.5,168.5C 323.338,168.158 323.672,167.492 323.5,166.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#616161",
    d: "M 320.5,148.5 C 322.043,154.28 323.043,160.28 323.5,166.5C 323.672,167.492 323.338,168.158 322.5,168.5C 322.682,166.409 322.348,164.409 321.5,162.5C 245.836,161.5 170.17,161.167 94.5,161.5C 93.8413,164.455 93.5079,167.455 93.5,170.5C 131.665,171.167 169.999,171.5 208.5,171.5C 247.378,171.494 286.045,170.827 324.5,169.5C 325.612,174.838 325.612,180.171 324.5,185.5C 321.916,186.393 319.249,186.726 316.5,186.5C 315.501,237.331 315.168,288.331 315.5,339.5C 315.167,340.833 314.833,340.833 314.5,339.5C 314.5,321.833 314.5,304.167 314.5,286.5C 314.5,256.167 314.5,225.833 314.5,195.5C 243.833,195.5 173.167,195.5 102.5,195.5C 102.5,243.5 102.5,291.5 102.5,339.5C 102.167,340.833 101.833,340.833 101.5,339.5C 101.5,288.5 101.5,237.5 101.5,186.5C 98.8127,186.664 96.146,186.497 93.5,186C 91.968,185.3 90.968,184.134 90.5,182.5C 91.9984,171.518 93.3318,160.518 94.5,149.5C 94.8333,149.5 95.1667,149.5 95.5,149.5C 94.9492,152.807 94.6159,156.14 94.5,159.5C 121.339,159.831 148.005,159.498 174.5,158.5C 196.758,159.489 219.092,159.822 241.5,159.5C 268.167,159.5 294.833,159.5 321.5,159.5C 321.737,158.209 321.404,157.209 320.5,156.5C 320.5,154.167 320.5,151.833 320.5,149.5C 320.5,149.167 320.5,148.833 320.5,148.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#cfdee5",
    d: "M 93.5,173.5 C 170.167,173.5 246.833,173.5 323.5,173.5C 324.114,177.135 324.448,180.802 324.5,184.5C 247.167,184.5 169.833,184.5 92.5,184.5C 92.3227,180.766 92.6561,177.099 93.5,173.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b4bec2",
    d: "M 320.5,156.5 C 321.404,157.209 321.737,158.209 321.5,159.5C 294.833,159.5 268.167,159.5 241.5,159.5C 241.5,158.833 241.833,158.5 242.5,158.5C 242.833,158.5 243.167,158.5 243.5,158.5C 269.522,159.157 295.188,158.491 320.5,156.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#494949",
    d: "M 173.5,156.5 C 196.425,157.489 219.425,157.822 242.5,157.5C 242.5,157.833 242.5,158.167 242.5,158.5C 241.833,158.5 241.5,158.833 241.5,159.5C 219.092,159.822 196.758,159.489 174.5,158.5C 173.662,158.158 173.328,157.492 173.5,156.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d1e1e8",
    d: "M 320.5,149.5 C 320.5,151.833 320.5,154.167 320.5,156.5C 295.188,158.491 269.522,159.157 243.5,158.5C 244.299,155.57 244.632,152.57 244.5,149.5C 269.833,149.5 295.167,149.5 320.5,149.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#cfdee5",
    d: "M 95.5,149.5 C 121.167,149.5 146.833,149.5 172.5,149.5C 172.198,152.059 172.532,154.393 173.5,156.5C 173.328,157.492 173.662,158.158 174.5,158.5C 148.005,159.498 121.339,159.831 94.5,159.5C 94.6159,156.14 94.9492,152.807 95.5,149.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 102.5,186.5 C 173.167,186.5 243.833,186.5 314.5,186.5C 314.5,189.167 314.5,191.833 314.5,194.5C 243.833,194.5 173.167,194.5 102.5,194.5C 102.5,191.833 102.5,189.167 102.5,186.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefd",
    d: "M 314.5,286.5 C 301.468,285.02 291.135,289.52 283.5,300C 265.343,298.827 253.843,306.994 249,324.5C 248.222,329.584 248.389,334.584 249.5,339.5C 200.5,339.5 151.5,339.5 102.5,339.5C 102.5,291.5 102.5,243.5 102.5,195.5C 173.167,195.5 243.833,195.5 314.5,195.5C 314.5,225.833 314.5,256.167 314.5,286.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6db434",
    d: "M 200.5,216.5 C 226.095,215.305 247.929,223.638 266,241.5C 269.748,249.722 267.248,253.555 258.5,253C 233.026,229.144 204.693,225.144 173.5,241C 168.546,244.285 163.88,247.952 159.5,252C 151.735,254.575 148.568,251.742 150,243.5C 163.522,228.322 180.355,219.322 200.5,216.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#636362",
    d: "M 355.5,220.5 C 356.325,222.125 355.992,223.792 354.5,225.5C 354.167,225.333 353.833,225.167 353.5,225C 354.267,223.53 354.933,222.03 355.5,220.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5e5e5d",
    d: "M 355.5,229.5 C 357.089,228.379 358.756,228.546 360.5,230C 358.803,230.384 357.137,230.218 355.5,229.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5d5d5c",
    d: "M 351.5,230.5 C 352.621,232.089 352.454,233.756 351,235.5C 350.616,233.803 350.782,232.137 351.5,230.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6db435",
    d: "M 200.5,238.5 C 221.474,236.989 239.307,243.655 254,258.5C 255.455,265.148 252.955,268.648 246.5,269C 235.291,258.929 222.124,253.762 207,253.5C 193.684,254.077 182.184,258.91 172.5,268C 166.566,270.273 163.233,268.107 162.5,261.5C 163.448,258.032 165.448,255.199 168.5,253C 178.149,245.671 188.815,240.838 200.5,238.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#727171",
    d: "M 331.5,250.5 C 335.459,249.578 337.792,251.078 338.5,255C 336.715,259.653 333.881,260.487 330,257.5C 329.167,254.829 329.667,252.496 331.5,250.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f8f8f8",
    d: "M 332.5,251.5 C 334.844,251.506 336.178,252.673 336.5,255C 334.551,259.634 332.551,259.634 330.5,255C 330.978,253.697 331.645,252.531 332.5,251.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6cb434",
    d: "M 201.5,260.5 C 216.253,259.391 229.086,263.724 240,273.5C 241.962,279.437 240.129,283.437 234.5,285.5C 229.33,282.414 223.997,279.581 218.5,277C 205.689,273.495 194.355,276.161 184.5,285C 177.232,284.684 174.732,280.85 177,273.5C 183.944,266.69 192.111,262.357 201.5,260.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#cecece",
    d: "M 355.5,263.5 C 354.167,262.5 354.167,261.5 355.5,260.5C 357.593,259.027 359.26,259.527 360.5,262C 359.26,264.473 357.593,264.973 355.5,263.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#727171",
    d: "M 355.5,263.5 C 357.593,264.973 359.26,264.473 360.5,262C 359.26,259.527 357.593,259.027 355.5,260.5C 358.067,257.734 360.067,258.234 361.5,262C 360.067,265.766 358.067,266.266 355.5,263.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6cb434",
    d: "M 203.5,283.5 C 217.152,282.044 223.319,288.044 222,301.5C 218.371,309.564 212.205,312.731 203.5,311C 191.524,301.755 191.524,292.589 203.5,283.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d2e2e9",
    d: "M 314.5,286.5 C 314.5,304.167 314.5,321.833 314.5,339.5C 292.833,339.5 271.167,339.5 249.5,339.5C 248.389,334.584 248.222,329.584 249,324.5C 253.843,306.994 265.343,298.827 283.5,300C 291.135,289.52 301.468,285.02 314.5,286.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.979
    },
    fill: "#d1e1e7",
    d: "M 316.5,186.5 C 316.167,220.173 316.5,253.84 317.5,287.5C 323.679,290.01 328.679,294.01 332.5,299.5C 336.122,300.659 339.789,300.825 343.5,300C 345.916,294.08 350.249,290.58 356.5,289.5C 357.167,289.5 357.5,289.167 357.5,288.5C 369.391,287.527 378.224,292.194 384,302.5C 389.773,314.792 390.773,327.459 387,340.5C 385.167,343.667 382.667,346.167 379.5,348C 361.836,348.5 344.17,348.667 326.5,348.5C 324.393,347.532 322.059,347.198 319.5,347.5C 319.662,345.473 319.495,343.473 319,341.5C 318.184,340.177 317.017,339.511 315.5,339.5C 315.168,288.331 315.501,237.331 316.5,186.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#929596",
    d: "M 101.5,339.5 C 101.833,340.833 102.167,340.833 102.5,339.5C 151.5,339.5 200.5,339.5 249.5,339.5C 271.167,339.5 292.833,339.5 314.5,339.5C 314.833,340.833 315.167,340.833 315.5,339.5C 317.017,339.511 318.184,340.177 319,341.5C 319.495,343.473 319.662,345.473 319.5,347.5C 318.691,348.469 317.691,349.302 316.5,350C 244.5,350.667 172.5,350.667 100.5,350C 98.0904,349.242 97.0904,347.575 97.5,345C 97.1419,341.867 98.4752,340.033 101.5,339.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d1e1e8",
    d: "M 99.5,341.5 C 172.167,341.5 244.833,341.5 317.5,341.5C 317.5,343.833 317.5,346.167 317.5,348.5C 244.833,348.5 172.167,348.5 99.5,348.5C 99.5,346.167 99.5,343.833 99.5,341.5 Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInternetPlanHover);
export default __webpack_public_path__ + "static/media/internet-plan-hover.059e64d828ed756788d684bd131ae6fc.svg";
export { ForwardRef as ReactComponent };